/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkout_Pay_ButtonInputs */

const en_checkout_pay_button = /** @type {(inputs: Checkout_Pay_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pay and book`)
};

/**
* | output |
* | --- |
* | "Pay and book" |
*
* @param {Checkout_Pay_ButtonInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const checkout_pay_button = /** @type {((inputs?: Checkout_Pay_ButtonInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkout_Pay_ButtonInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_checkout_pay_button(inputs)
});